import { createSelector } from '@reduxjs/toolkit'
import { MedSummaryReference } from './schemas'
import { RootState } from '@/store/store'
import { MedSummaryReferencesRecord } from './slice'

/**
 * Select: Med Summary References by parent ID
 *
 * Returns the record of medical billing summary references for the given parent
 * (legacy job or living asset), or null if it does not exist.
 */
export const selectMedSummaryReferences = createSelector(
  [(state: RootState) => state.medSummaryReferencesState.references, (_: RootState, props: { parentId: string | undefined | null }) => props.parentId],
  (references, parentId): MedSummaryReferencesRecord | null => {
    if (!parentId) return null
    return references[parentId] ?? null
  }
)

/**
 * Select: Med Summary Reference by ID
 *
 * Returns the medical billing summary reference with the given id, or null if it does not exist.
 */
export const selectMedSummaryReferenceById = createSelector(
  [selectMedSummaryReferences, (_: RootState, props: { parentId: string | undefined | null; referenceId: string }) => props.referenceId],
  (references, referenceId): MedSummaryReference | null => {
    if (!references || !referenceId) return null
    return references[referenceId] ?? null
  }
)
